import { useCallback } from "react";
import { PAYMENT_ALREADY_REGISTERED } from "../errors";

import { getRecaptchaToken } from "@/utils/recaptcha";
import { StatusCodes } from "http-status-codes";
import { PAYMENT_API_PATH } from "../../constants";

export default function useCheckEmail() {
  const checkEmail = useCallback(async (email: string) => {
    const recaptchaTokenForEmail = await getRecaptchaToken("submit");
    const getResponse = await fetch(
      `${PAYMENT_API_PATH}/check?email=${encodeURIComponent(email)}&recaptchaToken=${recaptchaTokenForEmail}`,
    );

    if (getResponse.status !== StatusCodes.NOT_FOUND) {
      throw new Error(PAYMENT_ALREADY_REGISTERED);
    }
  }, []);

  return { checkEmail };
}
